const koterBackground = './koter.png';

const blue = "#0053B3"

export const cssOverride = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  pointerEvents: "all",
  zIndex: 1000,
};

export const cssOverridePuffloader = {
  alignItems: "center",
  justifyContent: "center",
  margin: "auto",
  display: "flex",
  top: "33%",
  pointerEvents: "all",
  position: "relative"

};

export const fullScreenCenterStyle = {
  position: 'fixed', // Position relative to the viewport
  top: 0,
  left: 0,
  right: 0,  // Use right/bottom instead of width/height for simplicity
  bottom: 0,
  display: 'flex',        // Enable flex container
  alignItems: 'center',   // Center vertically
  justifyContent: 'center', // Center horizontally
  // zIndex and pointerEvents are handled by the Modal component itself
};

export const infoPanelStyle = {
  backgroundColor: "rgba(255, 255, 255, 0.9)",
  border: "1px solid #e0e0e0",
  borderRadius: "8px",
  padding: "20px",
  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  maxWidth: "400px",
  width: "100%",
  maxHeight: "90vh",
  overflowY: "auto",
  backgroundImage: `url(${koterBackground})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundBlendMode: "overlay",
  backgroundRepeat: "no-repeat"  
};

export const headingStyle = {
  fontSize: "24px",
  marginBottom: "16px",
  color: "#333333",
  textAlign: "center",
  textShadow: "1px 1px 2px rgba(255, 255, 255, 0.8)",
};

export const timeStyle = {
  fontSize: "16px",
  marginBottom: "16px",
  color: "#333333",
  textAlign: "center",
  textShadow: "1px 1px 2px rgba(255, 255, 255, 0.8)",
};

export const contentStyle = {
  marginBottom: "16px",
  backgroundColor: "rgba(255, 255, 255, 0.8)",
  padding: "10px",
  borderRadius: "4px",
};

export const linkStyle = {
  color: blue,
  textDecoration: "none",
  fontWeight: "bold",
};

export const checkboxContainerStyle = {
  display: "flex",
  alignItems: "center",
  marginTop: "12px",
};

export const checkboxStyle = {
  color: blue
};

export const buttonStyle = {
  backgroundColor: blue,
  color: "#ffffff",
  border: "none",
  borderRadius: "4px",
  padding: "8px 16px",
  fontSize: "14px",
  cursor: "pointer",
};
